module.exports = __webpack_public_path__ + "img/blank_profile.8a5f0958.svg";